











import { useWxSubscribe } from '@/hooks/use-wxsubscribe';
import { i18n } from '@/i18n';
import { CustomException, elk } from '@tencent/ppd-base-libs';
import { IconType, showToast } from '@tencent/wphk-act-base-ui';
import WxSubscribe from '@tencent/wphk-components-wx-subscribe/index.vue';
import { defineComponent, onUnmounted, ref, watch } from '@vue/composition-api';
export default defineComponent({
  name: 'SubscribeBtn',
  components: {
    WxSubscribe,
  },
  emits: ['click', 'close'],
  setup(props, context) {
    const wxSubscribe = useWxSubscribe();
    const { unSubscribeTmpIds } = wxSubscribe;
    const wxSubscribeBtn = ref<InstanceType<typeof WxSubscribe> | null>(null);

    const onFail = (res) => {
      context.emit('close');
      showToast({
        title: i18n('<p>無法訂閲</p><p>請咨詢客服</p>'),
        duration: 2500,
        icon: IconType.fail,
      });
      elk({
        key: 'wxSubscribe',
        str2: 'fail',
        msg: JSON.stringify(res),
      });
      new CustomException(res, 'wxSubscribeFail', '调用微信订阅失败');
    };
    const onSuccess = async (res) => {
      context.emit('close');
      const hasOneAccept = await wxSubscribe.handleSubscribeRes(res);
      if (hasOneAccept) {
        showToast({
          title: i18n('訂閱成功'),
          duration: 2500,
          icon: IconType.success,
        });
        wxSubscribe.updateSubScribe();
      }
      elk({
        key: 'wxSubscribe',
        str2: 'success',
        msg: JSON.stringify(res),
      });
    };

    function btnClick(e: Event) {
      context.emit('click');
      e.stopPropagation();
    }

    watch(wxSubscribeBtn, () => {
      const el = wxSubscribeBtn.value?.$el;
      if (el) {
        el.removeEventListener('click', btnClick);
        el.addEventListener('click', btnClick);
      }
    });

    onUnmounted(() => {
      const el = wxSubscribeBtn.value?.$el;
      el?.removeEventListener('click', btnClick);
    });


    return {
      unSubscribeTmpIds,
      wxSubscribeBtn,
      onFail,
      onSuccess,
    };
  },
});
